<template>

    <v-data-table
      :headers="headers"
      :items="payments"
      :loading="isLoading"
      hide-default-footer
      loading-text="general.loading"
      density="compact"
      :sort-by="[{ key: 'event_date_start', order: 'desc' }]"
      :items-per-page="-1"
      striped="even"
      hover
    >


      <template v-slot:[`item.event_date_start`]="{ item }">
        {{ $formatDate(item.event_date_start) }}
      </template>

      <template v-slot:[`item.event_name`]="{ item }">
        <router-link :to="'/soutez/' + item.event_id">{{ item.event_name }}</router-link> 
      </template>

      <template v-slot:[`item.export`]="{ item }">
        <a :href="`${BaseUrl}/export/?type=xlsx&event_id=${item.event_id}`" target="_blank">
          <v-icon color="green" size="30">mdi-microsoft-excel</v-icon>
        </a>
      </template>

      <template v-slot:[`item.total_category_fee`]="{ item }">
        <span style="white-space: nowrap">{{ Number(item.total_category_fee).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</span>
      </template>

      <template v-slot:[`item.total_service_fee`]="{ item }">
        <span style="white-space: nowrap">{{ Number(item.total_service_fee).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</span>
      </template>

      <template v-slot:[`item.payment_total`]="{ item }">
        <span style="white-space: nowrap">{{ Number(item.payment_total).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</span>
      </template>


      <!-- Extra řádek (footer) -->
      <template v-slot:[`body.append`]>
        <tr style="white-space: nowrap">
          <td colspan="3" class="text-right"><strong>{{ $t('club.payments.total') }}:</strong></td>
          <td><strong>{{ Number(totalCategoryFee).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</strong></td>
          <td><strong>{{ Number(totalServiceFee).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</strong></td>
          <td><strong>{{ Number(totalPayments).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</strong></td>
        </tr>
      </template>

    </v-data-table>
    <v-col cols="12" md="2">
      <SelectYear v-model="selectedYear" />

    </v-col>  

</template>





<script setup>

import { ref, computed, watch } from 'vue';
// import {useSnackbarStore} from '@/stores/snackbarStore'
import apiClient from '/api.js';
import { useRoute } from 'vue-router';
import SelectYear from '@/components/shared/SelectYear.vue';
import { useI18n } from 'vue-i18n'
import { currencySymbol } from '@/components/const/enums.js';
import {useAuthStore} from '/auth.js';


const props = defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  eventCurrency: {
    type: String,
    default: currencySymbol.CZK
  }
});

const authStore = useAuthStore();
const { t } = useI18n()

// Vypočítáme, zda je aktivní záložka club_payments
const isTabActive = computed(() => props.activeTab === 'club_payments');

// const snackbar = useSnackbarStore()
const route = useRoute();


// const errorMessage = ref('');


const club_shortcut = computed(() => route.params.id)
const BaseUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '').replace(/\/api\/?$/, '')); // Odstraní "api/" a nadbytečná lomítka


const isLoading = ref(false);
const payments = ref([]);
const selectedYear = ref(new Date().getFullYear()); // Výchozí rok je aktuální rok

const fetchPayments = async () => {
  isLoading.value = true;
  try {
    const response = await apiClient.get(`/payment/?club_shortcut=${club_shortcut.value}&year=${selectedYear.value}`);
    payments.value = response.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

// Výpočet celkové sumy plateb
const totalCategoryFee = computed(() => {
  return payments.value.reduce((sum, item) => sum + item.total_category_fee, 0);
});
const totalServiceFee = computed(() => {
  return payments.value.reduce((sum, item) => sum + item.total_service_fee, 0);
});
const totalPayments = computed(() => {
  return payments.value.reduce((sum, item) => sum + item.payment_total, 0);
});

// Definice hlaviček tabulky
const headers = [
  { title: t('club.payments.date'), value: 'event_date_start' },
  { title: t('club.payments.event_name'), value: 'event_name', minWidth:180 },
  { title: '', value: 'export', width: 50 },
  { title: t('club.payments.category_fee'), value: 'total_category_fee' },
  { title: t('club.payments.service_fee'), value: 'total_service_fee' },
  { title: t('club.payments.total'), value: 'payment_total' },
];



// Sledujeme změnu aktivní záložky
watch(isTabActive, (newVal) => {
  if (newVal) {
    fetchPayments();
  }
}, { immediate: true });


// Pokud se změní vybraný rok, opět načteme data (pokud je záložka aktivní)
watch(selectedYear, () => {
  if (isTabActive.value) {
    fetchPayments();
  }
});


</script>

<style scoped>



</style>